"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEmailIds = void 0;
const config_1 = require("./config");
const helpers_1 = require("./helpers");
const extractQueryParamsFromWindowLocation = () => {
    return window.location.search
        .replace('?', '')
        .split('&')
        .reduce((accumulate, param) => {
        const [paramKey, paramValue] = param.split('=');
        return paramKey in accumulate
            ? accumulate
            : Object.assign(Object.assign({}, accumulate), { [paramKey]: paramValue });
    }, {});
};
const getUserIdFromQueryParameters = (key) => {
    const queryParams = extractQueryParamsFromWindowLocation();
    const paramKey = config_1.config[key];
    const userId = queryParams[paramKey];
    return userId;
};
const getUserIdFromLocalStorage = (key) => {
    return localStorage.getItem(key);
};
const getUserId = (key) => {
    var _a;
    const paramsEmailUserIdHashed = getUserIdFromQueryParameters(key);
    if (paramsEmailUserIdHashed === undefined) {
        return (_a = getUserIdFromLocalStorage(key)) !== null && _a !== void 0 ? _a : undefined;
    }
    return paramsEmailUserIdHashed;
};
/**
 * Extracts from the the URL in the browser the defined email params, stores them in the local storage and returns them with the appropriate naming.
 * @returns A record including the currently defined user IDs
 */
const getEmailIds = () => {
    const result = (0, helpers_1.getKeysOf)(config_1.config).reduce((accumulate, userIdKey) => {
        const userIdValue = getUserId(userIdKey);
        return userIdValue === undefined
            ? accumulate
            : storeAndAppendToAccumulate(accumulate, userIdKey, userIdValue);
    }, {});
    return result;
};
exports.getEmailIds = getEmailIds;
const storeAndAppendToAccumulate = (accumulate, userIdKey, userIdValue) => {
    localStorage.setItem(userIdKey, userIdValue);
    return Object.assign(Object.assign({}, accumulate), { [userIdKey]: userIdValue });
};
